import { ENDPOINTS } from "./Endpoints"
import { GET } from "./Requests"

export default function PitLogin(username, password) {
    const url =
        ENDPOINTS.login + "?username=" + username + "&password=" + password
    return GET(url)
}
